// extracted by mini-css-extract-plugin
export default {"value":"YiLTHfJUwUijFGY1BF3c","currency":"ZWHB57x3gwwZlXiSngVw"};